"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Pagination = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var Pagination =
/*#__PURE__*/
function () {
  function Pagination(info) {
    this.size = info.size;
    this.num = info.num;
    this.total = info.total;
  }

  var _proto = Pagination.prototype;

  _proto.nextPage = function nextPage() {
    if (this.hasNextPage) {
      return this.num + 1;
    }

    return this.num;
  };

  _proto.prePage = function prePage() {
    if (this.hasPrePage) {
      return this.num - 1;
    }

    return this.num;
  };

  (0, _createClass2.default)(Pagination, [{
    key: "hasNextPage",
    get: function get() {
      return this.num < Math.ceil(this.total / this.size);
    }
  }, {
    key: "hasPrePage",
    get: function get() {
      return this.num > 1;
    }
  }]);
  return Pagination;
}();

exports.Pagination = Pagination;